var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs-cam"},[_c('h5',[_vm._v(_vm._s(_vm.xs.name))]),_c('h6',[_vm._v(_vm._s(_vm.xs.business))]),_c('h6',[_vm._v(_vm._s(_vm.xs.branch))]),_c('h6',[_vm._v(_vm._s(_vm.xs.area))])])}
var staticRenderFns = []

export { render, staticRenderFns }